var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 210,
    viewBox: "0 0 171 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.083 5.8335H25.8333C20.5732 5.8335 15.5285 7.92307 11.809 11.6425C8.08958 15.362 6 20.4067 6 25.6668V184.333C6 189.594 8.08958 194.638 11.809 198.358C15.5285 202.077 20.5732 204.167 25.8333 204.167H144.833C150.093 204.167 155.138 202.077 158.858 198.358C162.577 194.638 164.667 189.594 164.667 184.333V55.4168L115.083 5.8335Z",
    fill: "#ECF5FF",
    stroke: "#0473EA",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.167 5.8335V45.5002C105.167 50.7603 107.256 55.805 110.976 59.5244C114.695 63.2439 119.74 65.3335 125 65.3335H164.667M65.5 75.2502H45.6666M125 114.917H45.6666M125 154.584H45.6666",
    stroke: "#0473EA",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.162d558c560172287bd712d78186f8cb.svg";
export { ForwardRef as ReactComponent };